import { compose, withHandlers, withState } from 'recompose';

const popoversToClose = {};
export default (forceClosePopover = true) => compose(
  withState('anchorEl', 'setAnchorEl', null),

  withHandlers({
    'openPopover': ({ setAnchorEl }) => (event) => {
      if (forceClosePopover) popoversToClose[event.currentTarget] = () => setAnchorEl(null);
      setAnchorEl({ ...event }.currentTarget);
    },
    'closePopover': ({ anchorEl, setAnchorEl }) => () => {
      setAnchorEl(null);
      delete popoversToClose[anchorEl];
    },
  }),
);

export const closeAppPopovers = () => {
  Object.values(popoversToClose).forEach(closeFn => closeFn());
};
